/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whole_Awful_Cod_HackInputs */

const fr_whole_awful_cod_hack = /** @type {(inputs: Whole_Awful_Cod_HackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un rôle`)
};

/**

* @param {Whole_Awful_Cod_HackInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const whole_awful_cod_hack = /** @type {((inputs?: Whole_Awful_Cod_HackInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whole_Awful_Cod_HackInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_whole_awful_cod_hack(inputs)
});